import { Dispatch, SetStateAction } from 'react';
import { fontSizes } from '@instamenu/ui-vanilla-extract';
import { Skeleton } from '../skeleton/skeleton';
import { Button } from '../button/button';
import { ModalNext } from '../modal/modal';
import { Text } from '../text/text';
import { InlineAuth } from '../inline-auth/inline-auth';

export const SignIn = ({
  setShowModal,
  showModal,
  ready,
}: {
  setShowModal: Dispatch<SetStateAction<boolean>>;
  showModal: boolean;
  ready: boolean;
}) => {
  if (!ready) {
    return <Skeleton variant="rect" width={85} height={40} />;
  }
  return (
    <>
      <Button
        rectangular
        size="sm"
        variant="secondary"
        css={{ fontSize: fontSizes.small, height: '40px' }}
        onClick={() => setShowModal(true)}
      >
        Sign in
      </Button>
      <ModalNext
        opened={showModal}
        containerStyle={{ padding: 36 }}
        onRequestClose={() => setShowModal(false)}
      >
        <Text variant="h2" css={{ marginBottom: 24 }}>
          Sign in
        </Text>
        <InlineAuth />
      </ModalNext>
    </>
  );
};
